import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ProjectPicturesComponent } from "./public/project-pictures/project-pictures.component";

const routes: Routes = [
	{
		path: "",
		loadChildren: () =>
			import("./content/pages/pages.module").then(m => m.PagesModule)
	},
	{
		path: "project-pictures",
		// component: ProjectPicturesComponent
		loadChildren: () =>
			import("./public/project-pictures/project-pictures.module").then(
				m => m.ProjectPicturesModule
			)
	},
	{
		path: "contracts",
		loadChildren: () =>
			import("./public/contracts/contracts.module").then(
				m => m.ContractsModule
			)
	},
	{
		path: "**",
		redirectTo: "404",
		pathMatch: "full"
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always', anchorScrolling: 'enabled' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
